import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import { Storage } from '@ionic/storage'
import { ElectronService } from 'ngx-electron';
import { URL_ELECTRON_GLOBAL_PORT, URL_ELECTRON_IP } from '../../config/url.servicio';
@Injectable()
export class DesconectService {


  private url: string = `http://${URL_ELECTRON_IP}:${URL_ELECTRON_GLOBAL_PORT}`
  // private baseUrl: string = 'http://192.168.20.20';

  constructor(private http: Http,private storage: Storage, private _electronService: ElectronService) {
  }

  async getCompaniaInformacionMododesconectado(): Promise<any> {
    try {

        const response = await this.http.get(`${this.url}/buscarcompaniaInformacionMododesconectado`).toPromise();
        return response;



    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }

  async getCompaniaInformacionMododesconectadoError(params: any): Promise<any> {
    try {
      const response = await this.http.get(`${this.url}/buscarcompaniaInformacionMododesconectadoError`, { params }).toPromise();
      return response;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }

  async getBuscarInformacionMododesconectadoFormasDePago(): Promise<any> {
    try {
      const response = await this.http.get(`${this.url}/buscarInformacionMododesconectadoFormasDePago`).toPromise();
      return response;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }

  async getBuscarInformacionMododesconectadoParametrosGenerales(): Promise<any> {
    try {

      const response = await this.http.get(`${this.url}/buscarInformacionMododesconectadoParametrosGenerales`).toPromise();
      return response;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }

  async getBuscarInformacionMododesconectadoListagruposproductosCaja(): Promise<any> {
    try {

      const response = await this.http.get(`${this.url}/buscarInformacionMododesconectadoListagruposproductosCaja`).toPromise();
      return response;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }

  async getBuscarInformacionMododesconectadoProductosCaja(): Promise<any> {
    try {

      const response = await this.http.get(`${this.url}/buscarInformacionMododesconectadoProductosCaja`).toPromise();
      return response;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }


  async getBuscarInformacionMododesconectadoClienteGenerico(): Promise<any> {
    try {

      const response = await this.http.get(`${this.url}/buscarInformacionMododesconectadoClienteGenerico`).toPromise();
      return response;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }

  async getBuscarInformacionMododesconectadoMesas(): Promise<any> {
    try {

      const response = await this.http.get(`${this.url}/buscarInformacionMododesconectadoMesas`).toPromise();
      return response;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }


  async getBuscarInformacionMododesconectadoDenominaciones(): Promise<any> {
    try {

      const response = await this.http.get(`${this.url}/buscarInformacionMododesconectadoDenominaciones`).toPromise();
      return response;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }

  async getbuscarInformacionMododesconectadoMesasComandas(): Promise<any> {
    try {

      const response = await this.http.get(`${this.url}/buscarInformacionMododesconectadoMesasComandas`).toPromise();
      return response;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }

  async getBuscarInformacionMododesconectadoMesasDelete(): Promise<any> {
    try {

      const response = await this.http.get(`${this.url}/buscarInformacionMododesconectadoMesasDelete`).toPromise();
      return response;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }

  async guardarMododesconectadoTodos(datos): Promise<any> {
    try {

      const response = await this.http.get(`${this.url}/guardarMododesconectadoTodos?datos=${datos}`).toPromise();
      return response;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }









}



// WEBPACK FOOTER //
// ./src/providers/desconect/desconect-service.ts